import { render, staticRenderFns } from "./c-colorpicker.vue?vue&type=template&id=4f2129fd&scoped=true"
import script from "./c-colorpicker.vue?vue&type=script&lang=js"
export * from "./c-colorpicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2129fd",
  null
  
)

export default component.exports